module.exports = __webpack_public_path__ + "img/Im5.1e9df1ab.png";